import classNames from "classnames";

const ObservationModalGridPanel = ({ divider, scrollable, children }) => {
  return (
    <>
      {divider && <div className="observation-modal-grid-divider" />}
      <div
        className={classNames("observation-modal-grid-panel", {
          "-scrollable": scrollable,
        })}
      >
        {children}
      </div>
    </>
  );
};

export default ObservationModalGridPanel;
